var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenContainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#B6F6BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1875 20.3125V20.8125H32.6875H36.625C36.7637 20.8125 36.875 20.9238 36.875 21.0625V24.6875H19.125V21.0625C19.125 20.9238 19.2363 20.8125 19.375 20.8125H23.3125H23.8125V20.3125V19.125H24.5V20.3125V20.8125H25H31H31.5V20.3125V19.125H32.1875V20.3125ZM19.375 36.875C19.2363 36.875 19.125 36.7637 19.125 36.625V27.2812H36.875V36.625C36.875 36.7637 36.7637 36.875 36.625 36.875H19.375Z",
    fill: "#61CE70",
    stroke: "#61CE70"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenContainer);
export default __webpack_public_path__ + "static/media/green-container.a062aab4f13177e4c165f0c3ccb45915.svg";
export { ForwardRef as ReactComponent };